import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AssociatePrivateRoute from './AssociatePrivateRoute';

export const PERMESSO_FORMALITA_STAFF = 'formalita.admin_access';

/**
 * Accesso alla guida formalità e canali: staff con `formalita.admin_access` (sessione admin)
 * oppure, altrimenti, il normale controllo dell'area riservata associati.
 */
const FormalitaCanaliGate: React.FC = () => {
  const { user, loading, hasPermission } = useAuth();
  let tokenStaff = false;
  try { tokenStaff = !!localStorage.getItem('accessToken'); } catch { /* storage non disponibile */ }

  // Con una sessione staff in caricamento si aspetta, per non rimandare al login associati
  if (tokenStaff && loading) return null;
  if (user && hasPermission(PERMESSO_FORMALITA_STAFF)) return <Outlet />;
  return <AssociatePrivateRoute />;
};

export default FormalitaCanaliGate;
